import React from "react";
import { Box, useDisclosure } from "@chakra-ui/react";
import { AppDrawer } from "../AppDrawer";
import { Header } from "../Header";

export const PageLayout = ({ children, userRole, navListItems = [], user }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box>
      <Header
        isAuthenticated={true}
        user={user}
        userRole={userRole}
        onOpen={onOpen}
      />
      <AppDrawer
        isOpen={isOpen}
        onClose={onClose}
        placement="left"
        navListItems={navListItems}
        userRole={userRole}
        user={user}
      />
      <Box
        as="main"
        minHeight="calc(100vh - 64px)"
        backgroundColor="rgba(0,176,255,.05)"
        position="relative"
        zIndex="0"
      >
        {children}
      </Box>
    </Box>
  );
};
